import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { draftToForm } from '../utils/draftToForm';
import { useSaveDraftMutation } from '../api/useSaveDraftMutation';
import { useRouteParams } from './useRouteParams';
import { formToDraft } from '../utils/formToDraft';
import { DraftAccountDTO } from '../AccountOpening.meta';
import { selectIsUserClient } from '../../../CommonSelectors/CommonAreaSelector';

interface UseStepFormParams {
  draftAccount: DraftAccountDTO;
  onSuccess(): void;
  validation: any;
}

export const useStepForm = ({ draftAccount, onSuccess, validation }: UseStepFormParams) => {
  const isUserClient = useSelector(selectIsUserClient);

  const formBag = useForm({
    defaultValues: draftToForm(draftAccount),
    resolver: yupResolver(validation),
    context: { customerType: draftAccount.customerType, isUserClient },
  });

  const { clientId, draftId } = useRouteParams();

  const saveDraftMutation = useSaveDraftMutation();

  const onSubmit = async values => {
    const parsedValues = formToDraft(values, draftAccount);

    try {
      await saveDraftMutation.mutateAsync({
        clientId,
        id: draftId,
        data: { ...draftAccount, ...parsedValues },
      });

      onSuccess();
    } catch (err) {
      console.error(err);
    }
  };

  return {
    formBag,
    saveDraftMutation,
    onSubmit,
  };
};
